import { DesktopWizardProps } from '../../Types'
import { DesktopWizard } from '../../DesktopWizard/DesktopWizard'
import { PurposeAndGoals } from '../Steps/PurposeAndGoals/PurposeAndGoals'
import { TemplateAndCaption } from '../Steps/TemplateAndCaption/TemplateAndCaption'

export const FlowA2 = (props: DesktopWizardProps) => {
  let schema = { ...props.schema }

  return (
    <DesktopWizard {...props} schema={schema}>
      <PurposeAndGoals />
      <TemplateAndCaption />
    </DesktopWizard>
  )
}
